import Joi from "joi-browser";

const CreateAndEditLotSchema = Joi.object().keys({
    name: Joi.string()
        .trim()
        .required()
        .label("Name")
        .error((errors) => {
            function errorsAsString() {
                return "is required";
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    locationUrl: Joi.string()
        .regex(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
        )
        .label("Location Url")
        .allow("")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                if (err.type === "string.regex.base") {
                    return "must be a URL";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    materialId: Joi.string()
        .required()
        .label("Material")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                if (err.type === "any.empty") {
                    return "can't be an empty field.";
                } else {
                    return "is required";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
});

export default { CreateAndEditLotSchema };
